namespace Areas.Processes {
    "use strict";


    export function CreateTempContractAnalysis(a) {
        sendRequest("/ExecutiveReview/Processes/ExecuteTempContractAnalysis",
            null,
            "PUT");

        return;
    }

    export function CreateTempGeneralLedgerBalances(a) {
        sendRequest("/ExecutiveReview/Processes/ExecuteTempGeneralLedgerBalances",
            null,
            "PUT");

        return;
    }

    export function CreateTempGeneralLedgerBalancesSummary(a) {

        sendRequest("/ExecutiveReview/Processes/ExecuteTempGeneralLedgerBalancesSummary",
            null,
            "PUT");

        return;
    }

    export function CreateTempSchedulePWC(a) {
        sendRequest("/ExecutiveReview/Processes/ExecuteTempSchedulePWC",
            null,
            "PUT");

        return;
    }

    export function CreateTempProjectDataReview(a) {
        sendRequest("/ExecutiveReview/Processes/ExecuteTempProjectDataReview",
            null,
            "PUT");

        return;
    }

}
